import { RootState } from "redux/rootReducer";

export const selectIsLoadingDashboardInfo = (state: RootState) =>
  state.dashboardInfo.loading;
export const selectDashboardInfoErrorMessage = (state: RootState) =>
  state.dashboardInfo.error;
export const dashboardInfoResponse = (state: RootState) =>
  state.dashboardInfo.dashboardInfoResponse;
